import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-iackathon-intro-learner-page',
    imports: [
        MatIconModule,
        RouterLink,
        TranslateModule
    ],
  templateUrl: './iackathon-intro-learner-page.component.html',
})
export class IackathonIntroLearnerPageComponent {

    public readonly descriptions = [
        {
            icon: 'grid_view_rounded_fill',
            text: 'iackathon.four_phase_workshop_description_learner',
            title: 'iackathon.four_phase_workshop_learner',
        },
        {
            icon: 'construction',
            text: 'iackathon.introduction_to_ai_description_learner',
            title: 'iackathon.introduction_to_ai_learner',
        },
        {
            icon: 'automation_fill',
            text: 'iackathon.design_thinking_approach_description_learner',
            title: 'iackathon.design_thinking_approach_learner',
        },
        {
            icon: 'key_vertical_fill',
            text: 'iackathon.key_skills_description_learner',
            title: 'iackathon.key_skills_learner',
        },
    ] as const;
}
